import React, { cache } from 'react';
import { useRouter } from 'next/router';
import { useSession, signIn, signOut, getSession } from "next-auth/react";
import Image from "next/image";
import FCTLogoDark from "../../icons/fc-logo.png";
import EDXLogoLight from "../../public/images/edx-logo-light.png"
import EDXLogoDark from "../../public/images/edx-logo-dark.png"
import styles from "../../styles/Home.module.css";
import { useState, useEffect } from "react";
import Modal from 'react-modal';
import axios from "axios";
import ApiUrl from '../../url.json';
import cancelRequests from '../../utils/cancelRequests';

Modal.setAppElement('#__next');

export default function ResetPassModal({ isOpen, onRequestClose }) {

  const [images, setImages] = useState([]);
  //const [action, setAction] = useState('Sign In')
  const [topSuggestion, setTopSuggestion] = useState({ text: "Don't have an account?", action: "Register" })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [validPass, setValidPass] = useState(false)
  const [loading, setLoading] = useState(false)
  const { data: session } = useSession();
  const router = useRouter();
  const { createCancelableAxiosOptions, createCancelableFetchOptions } = cancelRequests();
  useEffect(() => {
    setError('')
    setSuccess('')
    setLoading('')
    setValidPass(false)
  }, [])

  function validateCapsLock(event) {
    if (event.getModifierState) {
      const isCapsLockOn = event.getModifierState('CapsLock');
      const errorSpan = document.getElementById('capsLockCheck');
      if (isCapsLockOn) {
        errorSpan.textContent = 'CapsLock is on';
      }
      else {
        errorSpan.textContent = '';
      }
    }
  }

  function validatePassword(event) {
    document.getElementById('pass-error').textContent = ''
    let passValidationSet = [];
    const password = event.target.value;
    const errorSpan = document.getElementById('password-validation-error');
    errorSpan.textContent = '';

    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      //return `Password must be at least ${minLength} characters long.`;
      const errorSpan = document.getElementById('minLength').style.color = 'red'
    }
    else {
      const errorSpan = document.getElementById('minLength').style.color = 'green'
      passValidationSet.push(password.length >= minLength)
      //errorSpan.textContent = `Password must be at least ${minLength} characters long.`;
    }
    if (!hasUpperCase) {
      const errorSpan = document.getElementById('capitalLetter').style.color = 'red'
      ///return 'Password must contain at least one uppercase letter.';
    }
    else {
      const errorSpan = document.getElementById('capitalLetter').style.color = 'green'
      passValidationSet.push(hasUpperCase)
    }
    if (!hasLowerCase) {
      const errorSpan = document.getElementById('smallLetter').style.color = 'red'
      //return 'Password must contain at least one lowercase letter.';
    }
    else {
      const errorSpan = document.getElementById('smallLetter').style.color = 'green'
      passValidationSet.push(hasLowerCase)
    }
    if (!hasNumber) {
      const errorSpan = document.getElementById('numericChar').style.color = 'red'
      //return 'Password must contain at least one number.';
    }
    else {
      const errorSpan = document.getElementById('numericChar').style.color = 'green'
      passValidationSet.push(hasNumber)
    }
    if (!hasSpecialChar) {
      const errorSpan = document.getElementById('specialChar').style.color = 'red'
      //return 'Password must contain at least one special character (e.g. !@#$%^&*).';
    }
    else {
      const errorSpan = document.getElementById('specialChar').style.color = 'green'
      passValidationSet.push(hasSpecialChar)
    }

    if (passValidationSet.length == 5) {
      const allTrue = passValidationSet.every(value => value === true);
      if (allTrue) {
        setValidPass(true)
        document.getElementById('passValidationWarning').style.display = 'none'
        document.getElementById('pass-success').textContent = 'valid'
        document.getElementById('pass-error').textContent = ''
        document.getElementById('temp').textContent = ''
        passValidationSet = []
      }
      else {
        document.getElementById('passValidationWarning').style.display = 'block'
        document.getElementById('pass-error').textContent = "Invalid format"
        document.getElementById('pass-success').textContent = ''
        setValidPass(false)
        passValidationSet = []
        //return false
      }
    }
    else {
      document.getElementById('passValidationWarning').style.display = 'block'
      document.getElementById('pass-error').textContent = "Invalid format"
      document.getElementById('pass-success').textContent = ''
      document.getElementById('required-error-newpass').textContent = ''
      setValidPass(false)
    }
  }

  function onPassFieldFocusEvent() {
    const warningDiv = document.getElementById('passValidationWarning');
    warningDiv.style.display = 'block'
    document.getElementById('temp').textContent = 'validating..'
  }
  function onPassFieldBlurEvent() {
    const warningDiv = document.getElementById('passValidationWarning');
    warningDiv.style.display = 'none'
    document.getElementById('temp').textContent = ''
  }


  async function handleSubmit(event) {

    event.preventDefault()
    // console.log("under submit")
    //handleSubmit
    const elements = document.querySelectorAll('[id^="required-error-"]');
    elements.forEach(element => {
      element.textContent = ''
    });
    document.getElementById('pass-error').textContent = ''
    let isFormValid = true
    const credentialData = new FormData(event.target)
    for (let key of credentialData.keys()) {
      if (credentialData.get(key).trim() === '') {
        const errorId = 'required-error-' + key
        const errorSpan = document.getElementById(errorId);
        errorSpan.textContent = 'required field';
        isFormValid = false
        return false
      }
    }
    if (!validPass) {
      document.getElementById('pass-error').textContent = "Invalid format"
      return false
    }
    if (credentialData.get('newpass') != credentialData.get('confirmnewpass')) {
      document.getElementById('pass-matching-error').textContent = 'passwords not matching'
      return false
    }
    if (isFormValid) {
      document.getElementById('pass-matching-error').textContent = ''
      document.getElementById('pass-error').textContent = ''
      setError('')
      //handle reset......
      if (session && session.user) {
        var currentpass = credentialData.get("currentpass")
        var newpass = credentialData.get("newpass")
        var apiurl = ApiUrl.newUrl + "/api/resetPassword";
        const options = createCancelableFetchOptions({
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            jwt: session.user.token
          },
          body: JSON.stringify({
            userid: session.user.userid,
            old: currentpass,
            new: newpass
          }),
        })
        try {
          const res = await fetch(apiurl, options);

          const resp = await res.json();
          // console.log(resp);
          if (resp && resp.success) {
            document.cookie = "jwt=" + session.user.token;
            localStorage.setItem('jwt', session.user.token);
            localStorage.setItem('userId', session.user.emailid);
            session.user.email = session.user.emailid;
            localStorage.setItem("globalid", session.user.emailid);
            localStorage.setItem('roles', session.user.roles);
            localStorage.setItem("_id", session.user.userid);
            localStorage.setItem("company", session.user.companyName);
            localStorage.setItem("name", session.user.name);
            const options = createCancelableAxiosOptions({
              headers: { jwt: session.user.token },
            });
            axios.post(ApiUrl.newUrl + '/api/GetMenuBarData', "", options)
              .then((result) => {
                const data = result.data;
                if (data) {
                  localStorage.setItem('menubardata', JSON.stringify(data.data));
                }
              })
              .catch((error) => {
                console.error('Error fetching menu bar data:', error);
              });
            setSuccess("password reset successfull");
            router.push('/jobs/all-jobs');
          }
          else {
            setError('Reset failed.')
          }
        }
        catch (e) {
          console.log(e?.message);
        }
      }
      else
        signOut();
    }
    else {
      return false
    }
  }

  return (<>
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={false}
      contentLabel="Reset Pass Modal"
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }
      }}
      className={styles.resetPassModal}
    >
      <div >
        <div className={styles.modalLogo}>
          {/* <button onClick={onRequestClose}>close</button> */}
          <Image src={EDXLogoLight} width={90} height={40} alt="" />
        </div>
        <div className={styles.modaltitle}>
          Reset Credentials
        </div>
        <div>
          {/* nessessry to make your accout secure. */}
        </div>
        <div className={styles.resetCredDiv}>
          <form id='reset' method="post" onSubmit={handleSubmit}>
            <table>
              <tr>
                <td>
                  <label htmlFor="currentpass" id="currentpass">Current Password :</label>
                </td>
                <td className={styles.tableInput}>
                  <input onKeyDown={(e) => validateCapsLock(e)} name="currentpass" id="currentpass" type="password" placeholder='Current Password' />
                  <span className={styles.validationError} id='required-error-currentpass'></span>
                </td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="newpass" id="newpass">New Password :</label>
                </td>
                <td className={styles.tableInput}>
                  <input onKeyDown={(e) => validateCapsLock(e)}
                    onFocus={() => onPassFieldFocusEvent()}
                    onBlur={() => onPassFieldBlurEvent()}
                    //onKeyUp={()=>{if(validPass){onPassFieldBlurEvent()}}}
                    onKeyUp={(e) => validatePassword(e)}
                    name="newpass"
                    id="newpass"
                    type="password"
                    placeholder='New Password' />
                  <span className={styles.validationError} id='required-error-newpass'></span>
                  <span className={styles.validationError} id='password-validation-error'></span>
                  <span className={styles.validationError} id='pass-error'></span>
                  <span className={styles.validationSuccess} id='pass-success'></span>
                  <span className={styles.validationSuccess} id='temp'></span>

                </td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="confirmnewpass" id="confirmnewpass">Conform New Password :</label>
                </td>
                <td className={styles.tableInput}>
                  <input onKeyDown={(e) => validateCapsLock(e)} name="confirmnewpass" id="confirmnewpass" type="password" placeholder='Confirm New Password' />
                  <span className={styles.validationError} id='required-error-confirmnewpass'></span>
                  <span className={styles.validationError} id='pass-matching-error'></span>
                </td>
              </tr>
            </table>
            <br></br>
            <div id='passValidationWarning' className={styles.passValidationWarning}>
              <span id='capitalLetter'>at least one capital letter</span><br></br>
              <span id='smallLetter'>at least one small letter</span><br></br>
              <span id='specialChar'>one special character.</span><br></br>
              <span id='numericChar'>one numeric character.</span><br></br>
              <span id='minLength'>minimum length 6</span>
            </div>
          </form>

          <span id='capsLockCheck' className={styles.capsLockError}></span>
          <button form='reset' disabled={loading} className={styles.loginButton}>Reset</button>
          {success && <span className={styles.success}>{success}</span>}
        </div>
      </div>
    </Modal>
  </>)
}